module.exports = __webpack_public_path__ + "static/media/izlozba (8).0df20c4d.jpg";